import Fn from "./fn";
const arr = [
  {
    id: 0,
    name: "返回",
    android: "quit",
    ios: "back",
    // iosClick: "inviteMoney",
    iosClick: "activityService",
    androidClick: "activityService",
  },
  {
    id: 1,
    name: "分享",
    android: "",
    ios: "toShareInvite",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 2,
    name: "中奖消息列表",
    android: "toInviteWinPrize",
    ios: "toPrizeListInvite",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 3,
    name: "选择地址",
    android: "toSelectExpressAddress",
    ios: "toSelectAddressInvite",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 4,
    name: "我的地址",
    android: "toMyAddress",
    ios: "toAddressListInvite",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 5,
    name: "保存图片",
    android: "toSaveImage",
    ios: "toAddressListInvite",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 6,
    name: "通用充值券",
    android: "toRecharge",
    ios: "toCurrencyCouponData",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  // {
  //   id: 6,
  //   name: "通用充值券",
  //   android: "toRechargeDetail",
  //   ios: "toCurrencyCouponList",
  //   iosClick: "inviteMoney",
  //   androidClick: "activityService",
  // },
  {
    id: 7,
    name: "重新登录",
    android: "toLogin",
    ios: "back",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 8,
    name: "分享至微信",
    android: "toShareWX",
    ios: "",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 9,
    name: "分享至微信朋友圈",
    android: "toShareWXFriends",
    ios: "",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 10,
    name: "分享至qq",
    android: "toShareQQ",
    ios: "",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 11,
    name: "复制链接",
    android: "toCopyUrl",
    ios: "",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 12,
    name: "抽奖分享",
    android: "",
    ios: "toShareInviteRaffle",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 13,
    name: "获取信息",
    android: "info",
    ios: "info",
    iosClick: "inviteMoney",
    androidClick: "activityService",
  },
  {
    id: 14,
    name: "进详情页",
    android: "toGame",
    ios: "toGameDetailPage",
    iosClick: "activityService",
    androidClick: "activityService",
  },
  {
    id: 15,
    name: "启动游戏",
    android: "startGame",
    ios: "startGame",
    iosClick: "iOSEditorService",
    androidClick: "editorService",
  },
  {
    id: 16,
    name: "微信好友分享",
    android: "toShareTextWX",
    ios: "toRaffleShare",
    iosClick: "activityService",
    androidClick: "activityService",
  },
];
export const connectWebViewJavascriptBridge = (index, val, list?) => {
  const rawMobile = sessionStorage.getItem("device") || Fn.mobile();
  const mobile = rawMobile ? String(rawMobile).toLowerCase() : "";
  const bridge = arr[index];
  if (!bridge || (mobile !== "ios" && mobile !== "android")) {
    return;
  }
  const obj = {
    [bridge[mobile]]: mobile === "ios" && bridge.id === 3 && !val ? "0" : val,
    ...list,
  };
  if (mobile === "ios") {
    const webkit = (window as any).webkit;
    const messageHandlers = webkit && webkit.messageHandlers;
    const handler = messageHandlers && messageHandlers[bridge.iosClick];
    if (!handler || !handler.postMessage) {
      return;
    }
    handler.postMessage({
      key: "getUrl",
      data: {
        ...obj,
      },
      callBack: "callBack",
    });
    return;
  }
  const data = JSON.stringify(obj);
  const boxAndroid = (window as any).BoxAndroid;
  if (!boxAndroid || !boxAndroid.callback) {
    return;
  }
  boxAndroid.callback(bridge.androidClick, data);
};
